import React, { useState } from 'react';
import { Divider, Typography } from '@mui/material';
import { useRole } from '../../../../utils/RoleContext';
import NavGroup from './NavGroup';
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import getMenuItems from 'menu-items';

function MenuList() {
    const { role } = useRole();
    const menuItems = getMenuItems(role);

    const [openCollapse, setOpenCollapse] = useState(null);

    return menuItems.items.map((item, index) => {
        if (item.disabled) return null;

        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;

            case 'collapse':
                return (
                    <NavCollapse
                        key={item.id}
                        menu={item}
                        level={1}
                        openCollapse={openCollapse}
                        setOpenCollapse={setOpenCollapse}
                    />
                );

            case 'item':
                return <NavItem key={item.id} item={item} />;

            case 'divider':
                return (
                    <Divider
                        key={index}
                        sx={{ borderColor: 'white', width: '100%', mb: 1 }}
                    />
                );

            default:
                return (
                    <Typography
                        key={item.id || index}
                        variant="h6"
                        color="error"
                        align="center"
                    >
                        Menu Items Error
                    </Typography>
                );
        }
    });
}

export default MenuList;